<nav role="navigation" class="navbar navbar-default navbar-fixed-top">
    <div class="container-fluid">
        <div class="navbar-header" (click)="headerClick()">
            <button class="btn btn-link pull-left navbar-toggler" *ngIf="!customerView"
                    type="button" aria-label="Toggle navigation" (click)="toggleSideMenu()">
                <span class="sr-only">Toggle navigation</span>
                <i class="fa fa-2x" [class._subOpen]="selectedMenu && subMenuOpen"
                   [ngClass]="{'fa-bars': !isSideMenuShow, 'fa-chevron-circle-left': isSideMenuShow}"></i>
            </button>

            <div class="chep-logo-container">
                <a class="chep-logo-link" href="#">
                    <img *ngIf="!loadTrackingView" class="chep-logo" src="/assets/chep_logo_blue.svg" alt="CHEP" />
                    <img *ngIf="loadTrackingView" class="chep-logo my-loads-logo" src="/assets/my-loads.png" alt="myLOADS" />
                </a>
            </div>

            <div class="dropdown-container logged-user pull-right dropdown-toggle" *ngIf="authService.isAuthenticated()"
                 [ngClass]="{'open' : isUserDropdownOpen}" (click)="isUserDropdownOpen = !isUserDropdownOpen">
                <span class="logged-user-name">{{authService.getUserProfile().nickname}}</span>
                <span class="caret"></span>
                <ul class="dropdown-menu dropdown-menu-right">
                <li>
                    <a class="dropdown-item" (click)="requestPasswordChange()" [i18n]="[{target: 'innerHTML', key: 'nav.change-password'}]"></a>
                </li>
                <li>
                    <a class="dropdown-item" (click)="logout()" [i18n]="[{target: 'innerHTML', key: 'nav.logout'}]"></a>
                </li>
                </ul>
            </div>

            <div class="select-language pull-right">
                <app-language-picker></app-language-picker>
            </div>

            <div class="btnAccess4Desk-container" *ngIf="authService.canViewServiceDeskLink()">
                 <a class="btnAccess4Desk" href="{{serviceDeskUrl}}" target="_blank">
                     <img src="./assets/bluechat.svg">
                     <i class="fas fa-external-link-alt"></i>
                 </a>
            </div>
        </div>
    </div>
</nav>

<div class="stack stack-left main-menu" [ngClass]="{'fade-in' : isSideMenuShow}" [class._subOpen]="selectedMenu && subMenuOpen">
    <div class="stack-container" [ngClass]="{'hide' : !isSideMenuContainerShow}" (click)="toggleSideMenu()">
        <div id="mainMenu" class="stack-item" tabindex="-1" [ngClass]="{'active current' : isSideMenuShow}" (click)="$event.stopPropagation()">
            <div class="panel panel-primary">
                <div class="panel-body">
                    <ul class="list-group main-group">
                        <li class="list-group-item" *ngIf="authService.isAuthenticated()">
                            <a class="expand-link home-link" [routerLink]="homeUri" [routerLinkActive]="'active'" (click)="toggleSideMenu()"
                               [i18n]="[{target: 'attribute:title', key: subMenuOpen ? 'nav.dashboard' : ''}]">
                                <i class="fa fa-fw" [ngClass]="'fa-home'"></i>
                                <span *ngIf="!subMenuOpen" [i18n]="'nav.dashboard'"></span>
                            </a>
                        </li>

                        <ng-container>
                            <ng-container *ngFor="let navItem of navItems">
                                <ng-container *ngIf="!navItem.items">
                                    <li class="list-group-item" *ngIf="navItem.displayed() && (navItem.guard != null ? (navItem.guard | async) : true)"
                                        [ngClass]="{'active current' : selectedMenu === navItem}">
                                        <a class="expand-link" [routerLink]="navItem.navigation?.getUri()" [routerLinkActive]="'active'" (click)="toggleSideMenu()"
                                           [i18n]="[{target: 'attribute:title', key: subMenuOpen ? navItem.translationKey : ''}]">
                                            <i *ngIf="navItem.iconClass" class="fa-fw" [ngClass]="navItem.iconClass"></i>
                                            <span *ngIf="!subMenuOpen" [i18n]="[{target: 'innerHTML', key: navItem.translationKey }]"></span>
                                        </a>
                                    </li>
                                </ng-container>

                                <ng-container *ngIf="navItem.items">
                                    <li class="list-group-item" *ngIf="navItem.displayed()" [ngClass]="{'active current' : selectedMenu === navItem}">
                                        <a class="expand-link" (click)="selectMenuItem(navItem)" [i18n]="[{target: 'attribute:title', key: subMenuOpen ? navItem.translationKey : ''}]">
                                            <i class="fa fa-fw" [ngClass]="navItem.iconClass || 'fa-folder'"></i>
                                            <span *ngIf="!subMenuOpen" [i18n]="[{target: 'innerHTML', key: navItem.translationKey }]"></span>
                                        </a>
                                    </li>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ul>

                    <ul class="list-group footer-group">
                        <li class="list-group-item">
                            <a class="expand-link privacy-link" href="https://cmastrg.blob.core.windows.net/privacy-notice/gb_v3.html" target="_blank"
                               [i18n]="[{target: 'attribute:title', key: subMenuOpen ? 'nav.privacy-notice' : ''}]">
                                <i class="fa fa-fw m-r" [ngClass]="'fas fa-gavel'"></i>
                                <span *ngIf="!subMenuOpen" [i18n]="'nav.privacy-notice'"></span>
                            </a>
                        </li>
                        <li class="list-group-item">
                            <ng-container *ngIf="authService.isAuthenticated(); else loginButton">
                                <a class="expand-link logout-link"
                                   *ngIf="authService.isAuthenticated()"
                                   (click)="logout()">
                                    <i class="fa fa-fw m-r" [ngClass]="'fa fa-sign-out-alt'"></i>
                                    <span *ngIf="!subMenuOpen" [i18n]="'nav.logout'"></span>
                                </a>
                            </ng-container>
                            <ng-template #loginButton>
                                <a class="expand-link logout-link"
                                   (click)="login()">
                                    <i class="fa fa-fw m-r" [ngClass]="'fa fa-sign-in-alt'"></i>
                                    <span *ngIf="!subMenuOpen" [i18n]="'nav.login'"></span>
                                </a>
                            </ng-template>

                                <div *ngIf="!subMenuOpen"  class="m-sm text-center">
                                    <span [i18n]="'login.version'"></span><span> : {{version}}</span>
                                </div>
                        </li>
                    </ul>
                </div>

                <div class="panel-sub" *ngIf="selectedMenu && subMenuOpen">
                    <div class="sub-menu-title" [i18n]="selectedMenu.translationKey"></div>
                    <div class="sub-menu no-padding">
                        <ul class="list-group">
                            <ng-container *ngFor="let navSubItem of selectedMenu.items">
                                <li class="list-group-item" *ngIf="navSubItem.displayed()"
                                    [class._dropdownOpen]="navSubItem.isOpen && navSubItem.items && navSubItem.items.length > 0">
                                    <ng-container *ngIf="!navSubItem.items">
                                        <a [routerLink]="navSubItem.navigation?.getUri()" [routerLinkActive]="'active'" (click)="toggleSideMenu()">
                                            <i class="fa-fw" [ngClass]="navSubItem.iconClass"></i>
                                            <span [i18n]="navSubItem.translationKey"></span>
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="navSubItem.items">
                                        <a (click)="navSubItem.isOpen = !navSubItem.isOpen">
                                            <i class="fa-fw" [ngClass]="navSubItem.iconClass"></i>
                                            <span [i18n]="navSubItem.translationKey"></span>
                                            <i class="dropdownArrow fa"  [ngClass]="{'fa-chevron-circle-down': !navSubItem.isOpen, 'fa-chevron-circle-up': navSubItem.isOpen}"></i>
                                        </a>
                                    </ng-container>
                                </li>

                                <ul class="list-group" *ngIf="navSubItem.isOpen && navSubItem.items && navSubItem.items.length > 0"
                                    [class._dropdownOpen]="navSubItem.isOpen && navSubItem.items && navSubItem.items.length > 0">
                                    <ng-container *ngFor="let navSubSubItem of navSubItem.items">
                                        <li class="list-group-item" *ngIf="navSubSubItem.displayed()">
                                            <a [routerLink]="navSubSubItem.navigation?.getUri()" [routerLinkActive]="'active'" (click)="toggleSideMenu()">
                                                <span [i18n]="navSubSubItem.translationKey"></span>
                                            </a>
                                        </li>
                                    </ng-container>
                                </ul>
                            </ng-container>
                        </ul>
                    </div>
                    <div class="panel-sub-icon">
                        <i [ngClass]="selectedMenu.iconClass"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
